import {
	formatDOB,
	formatDate,
	formatDateTime,
	formatMoveInDate,
	formatPipelineDateTime,
	formatShortDate,
} from '#app/utils/application-detail-v2/vendor/format-date'
import { useHints } from '#app/utils/client-hints'

const DEFAULT_TIMEZONE = 'America/Toronto'

/**
 * Client-side hook that automatically injects the user's timezone from client hints.
 * Usage: `const { formatDate } = useFormatDate()`
 */
export function useFormatDate() {
	const hints = useHints()
	const tz = DEFAULT_TIMEZONE
	return {
		formatDate: (d: string | Date | null | undefined) =>
			formatDate(d, { timeZone: tz }),
		formatShortDate: (d: string | Date | null | undefined) =>
			formatShortDate(d, { timeZone: tz }),
		formatDateTime: (d: string | Date | null | undefined) =>
			formatDateTime(d, { timeZone: tz }),
		/** "21 July, 2026, 04:00 PM" — pipeline cards + the report pages'
		 * Applicant Consent timestamp (client 2026-09-09). */
		formatPipelineDateTime: (d: string | Date | null | undefined) =>
			formatPipelineDateTime(d, { timeZone: tz }),
		formatDOB: (d: string | Date | null | undefined) =>
			formatDOB(d, { timeZone: tz }),
		formatMoveInDate: (d?: string | null) =>
			formatMoveInDate(d, { timeZone: tz }),
	}
}
